<aims-common-table
id="asset-config-manufacturers"
[dataSource]="resources | async"
[header]="header"
[pageSize]="10"
[permissions]="tablePermissions| async"
[addRowInitialObject]="initialTableObject"
(rowUpdated)="handleRowUpdate($event)"
(rowAdded)="handleRowAdd($event)"
(rowDeleted)="handleRowDelete($event)"
>
</aims-common-table>
